"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationMenuContent = void 0;
var _mui = require("@ori-ui/mui");
var _auth = require("@ori/auth");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useDeleteNotification = require("../hooks/useDeleteNotification");
var _useMarkAsReadNotification = require("../hooks/useMarkAsReadNotification");
var _useNotifications = require("../hooks/useNotifications");
var _localOperations = require("../utils/localOperations");
var _DeletedNotificationSnackback = require("./DeletedNotificationSnackback");
var _FormattedMessage = require("./FormattedMessage");
var _NotificationsList = require("./NotificationsList");
var _ScrollableBox = require("./ScrollableBox");
var _jsxRuntime = require("react/jsx-runtime");
const NotificationListContainer = (0, _mui.styled)(_mui.List)(() => ({
  padding: 0
}));
const ContainerTitle = (0, _mui.styled)(_mui.ListSubheader)(({
  theme
}) => ({
  backgroundColor: theme.palette.common.white,
  paddingTop: '1.2rem',
  textAlign: 'center',
  [theme.breakpoints.up(600)]: {
    textAlign: 'inherit'
  }
}));
const NotificationMenuContent = ({
  isVisible
}) => {
  const {
    token
  } = (0, _auth.useToken)();
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const [isFetchingEnabled, setIsFetchingEnabled] = (0, _react.useState)(isVisible && !!token);
  const {
    data: notifications,
    mutate: mutateNotifications
  } = (0, _useNotifications.useNotifications)(isFetchingEnabled);

  // After the user closes the notification menu the items should stay there,
  // but without this the isVisible is set to false and useNotifications will return undefined for its data
  // This way we ensure that when user opens the notification multiple times it stays constant
  if (!isFetchingEnabled && isVisible && !!token) {
    setIsFetchingEnabled(true);
  }
  const [deleteNotification, {
    data: lastDeletedNotification,
    clear: clearLastDeletedNotification,
    restore: restoreLastDeletedNotification,
    error: deleteNotificationError
  }] = (0, _useDeleteNotification.useDeleteNotification)();
  const [markNotificationAsViewed] = (0, _useMarkAsReadNotification.useMarkAsReadNotification)();
  const hasNotifications = notifications !== undefined && (Boolean(notifications.notifications.new.length) || Boolean(notifications.notifications.earlier.length));
  const handleDelete = (0, _react.useCallback)(async (notification, index, sectionName) => {
    // Delete notification from shown list of notification
    await mutateNotifications(localNotifications => (0, _localOperations.deleteNotificationLocally)(localNotifications, notification.notificationId ?? ''), false);
    const didDelete = await deleteNotification({
      ...notification,
      index,
      sectionName
    });

    // Return back the notification into shown list of notifications
    if (!didDelete) {
      await mutateNotifications(localNotifications => (0, _localOperations.undoDeleteLocally)({
        localNotifications,
        notification,
        index,
        section: sectionName
      }), false);
    }
  }, [mutateNotifications, deleteNotification]);
  const handleMarkAsViewed = (0, _react.useCallback)(async notification => {
    await mutateNotifications(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- its there at this point
    localNotifications => (0, _localOperations.markAsViewedLocally)(localNotifications, notification.notificationId), false);
    await markNotificationAsViewed(notification);
  }, [mutateNotifications, markNotificationAsViewed]);
  const handleRestore = (0, _react.useCallback)(async () => {
    if (!lastDeletedNotification) {
      return;
    }
    const {
      sectionName,
      index,
      ...notification
    } = lastDeletedNotification;

    // Show the notification immediately
    await mutateNotifications(localNotifications => (0, _localOperations.undoDeleteLocally)({
      localNotifications,
      notification,
      index,
      section: sectionName
    }), false);
    const didRestore = await restoreLastDeletedNotification();
    if (!didRestore) {
      // Remove notification from the list again
      await mutateNotifications(localNotifications => (0, _localOperations.deleteNotificationLocally)(localNotifications, notification.notificationId ?? ''), false);
    }
  }, [lastDeletedNotification, mutateNotifications, restoreLastDeletedNotification]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ScrollableBox.ScrollableBox, {
    dynamicHeight: !hasNotifications,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(NotificationListContainer, {
      ...getTestIdProps('notifications'),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ContainerTitle, {
        disableSticky: true,
        inset: false,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "h5",
          color: "textPrimary",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
            id: "Notifications"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotificationsList.NotificationList, {
        notificationsData: notifications,
        handleDelete: handleDelete,
        handleMarkAsViewed: handleMarkAsViewed
      })]
    }), lastDeletedNotification !== undefined || deleteNotificationError !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeletedNotificationSnackback.DeletedNotificationSnackback, {
      deletedNotification: deleteNotificationError === undefined && lastDeletedNotification ? lastDeletedNotification : false,
      onRestore: handleRestore,
      onRequestClose: clearLastDeletedNotification
    }) : null]
  });
};
exports.NotificationMenuContent = NotificationMenuContent;
